'use client';

import { GetPageComponentViewModel } from '@/types/cml-api';
import { useFetchGoodbyeSummerData } from './use-fetch-goodbye-summer-data';
import ProductsList from '../products-list-carousel/products-list';
import Skeleton from '../products-list-carousel/skeleton';
interface Props {
  data: GetPageComponentViewModel;
  isLazy: boolean;
}
const CustomProductList = ({
  data,
  isLazy
}: Props) => {
  const {
    data: goodbyeSummerItems,
    isLoading,
    isError
  } = useFetchGoodbyeSummerData();
  const filteredItemsBasedOnTitle = data?.title === 'جذاب‌ترین‌ها' ? goodbyeSummerItems?.[1] : goodbyeSummerItems?.[0];
  if (isLoading) {
    return <div className='homepage-container'>
                <div className='relative h-[250px] w-full overflow-hidden lg:h-[282px]'>
                    <Skeleton isPinkBox={false} />
                </div>
            </div>;
  }
  if (isError || !filteredItemsBasedOnTitle) return null;
  const goodbyeSummerData: GetPageComponentViewModel = {
    ...data,
    items: [filteredItemsBasedOnTitle]
  };
  return <ProductsList data={goodbyeSummerData} isLazy={isLazy} isGoodbyeSummerLanding data-sentry-element="ProductsList" data-sentry-component="CustomProductList" data-sentry-source-file="custom-product-list.tsx" />;
};
export default CustomProductList;